import React from 'react';

const PaymentPage = () => {
    return (
        <div>
            <h1>Payment Page</h1>
            {/* Include your payment form here */}
        </div>
    );
};

export default PaymentPage; 